import { render, staticRenderFns } from "./ResultMessage.vue?vue&type=template&id=e23ee01c&scoped=true&"
import script from "./ResultMessage.vue?vue&type=script&lang=js&"
export * from "./ResultMessage.vue?vue&type=script&lang=js&"
import style0 from "./ResultMessage.vue?vue&type=style&index=0&id=e23ee01c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e23ee01c",
  null
  
)

export default component.exports